import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ProductivityEventsService } from '@app-services/productivity-events/productivity-events.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnChanges {
  @Input() clearFilter: boolean;
  @Output() changeDate = new EventEmitter<any>();
  selectedType: string;
  date = {
    startDate: '',
    endDate: '',
  };

  constructor(private productivityEventsService: ProductivityEventsService) {}

  onSelect($event) {
    const date = new Date($event);
    this.selectedType = this.selectedType ? this.selectedType : 'startDate';
    this.date[this.selectedType] =
      this.productivityEventsService.formatDate(date);
    if (this.date.startDate !== '' && this.date.endDate !== '') {
      this.changeDate.emit(this.date);
    }
    this.selectedType = 'endDate';
  }

  onFocus(type) {
    this.selectedType = type;
  }

  clearDateFilter() {
    this.date = {
      startDate: '',
      endDate: '',
    };
    this.selectedType = 'startDate';
    this.changeDate.emit(this.date);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.clearFilter?.currentValue) {
      this.clearDateFilter();
    }
  }
}
